import { EmpresaResponse } from '../../../../types/empresa';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import UpdateRoundedIcon from '@mui/icons-material/UpdateRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

interface Props {
    empresa: EmpresaResponse;
}

export function VisitasGeneralInfo({ empresa }: Props) {
    return (
        <div className="flex h-1/2 gap-2 justify-between items-center px-3">

            {empresa.fechaContacto && (
            <div className="max-[1310px]:flex">
                <div className="flex text-center gap-1 items-center">
                    <CalendarMonthRoundedIcon />
                    <p className="font-medium max-[1310px]:hidden text-sm">Primer contacto:</p>
                </div>
                <p className="text-center">{empresa.fechaContacto ?? "-"}</p>
            </div>
            )}

            <div className="max-[1310px]:flex">
                <div className="flex text-center gap-1 items-center">
                    <CalendarMonthRoundedIcon />
                    <p className="font-medium max-[1310px]:hidden text-sm">Prospectación:</p>
                </div>
                <p className="text-center">{empresa.fechaProspectacion ?? "-"}</p>
            </div>

            <div className="max-[1310px]:flex">
                <div className="flex text-center gap-1 items-center">
                    <CalendarMonthRoundedIcon />
                    <p className="font-medium max-[1310px]:hidden text-sm">Última visita:</p>
                </div>
                <p className="text-center">{empresa.ultimaVisita ?? "-"}</p>
            </div>

            <div className="max-[1310px]:flex">
                <div className="flex text-center gap-1 items-center">
                    <CalendarMonthRoundedIcon />
                    <p className="font-medium max-[1310px]:hidden text-sm">Próxima visita:</p>
                </div>
                <p className="text-center">{empresa.fechaProximaVisita ?? "-"}</p>
            </div>

            <div className="max-[1310px]:flex">
                <div className="flex text-center gap-1 items-center">
                    <UpdateRoundedIcon />
                    <p className="font-medium max-[1310px]:hidden text-sm">frecuencia de visitas:</p>
                </div>
                <p className="text-center">{empresa.frecuenciaVisita}</p>
            </div>

            <div className="max-[1310px]:flex">
                <div className="flex text-center gap-1 items-center">
                    <AccessTimeRoundedIcon />
                    <p className="font-medium max-[1310px]:hidden text-sm">Tiempo desde la última visita:</p>
                </div>
                <p className="text-center">{empresa.tiempoDesdeUltimaVisita ?? "0 días"}</p>
            </div>

        </div>
    );
}